export enum IconThemeType {
  smoothicon = 'smoothicon',
  curveicon = 'curveicon',
}
